import { useQuery } from '@tanstack/react-query';

import { getTriggers } from '~/api/triggers';
import { Trigger } from '~/entities/Trigger';

export const useTriggers = (activeRealm: string): Trigger[] => {
  const { data } = useQuery({
    queryKey: ['run', 'triggers', activeRealm],
    queryFn: () => getTriggers(activeRealm),
    enabled: !!activeRealm,
    staleTime: 5 * 60 * 1000
  });

  return data ?? [];
};
